import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './App/';

// eslint-disable-next-line react/jsx-filename-extension
ReactDOM.render(
  // eslint-disable-next-line react/jsx-filename-extension
  <App />,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// src/index.js